import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import TranslatedText from '../../../translations/TranslatedText';

const SignUpActions = ({ registering, registerConfirm }) => (
    <div className="signup-btns">
        {!registering && (
            <div className="help-msg msg-register">
                <TranslatedText transKey='By registering you agree to our' />
                &nbsp;
                <a href="/terms.html" target="_blank" className="art-link-underline">
                    <TranslatedText transKey='T&C' />
                </a>
                &nbsp;
                <TranslatedText transKey='of Arteia' />
            </div>
        )}
        <button className="art-btn" onClick={registerConfirm}>
            <TranslatedText transKey="Create collection" />
        </button>
        <Link className="secondary-link" to="/login">
            <TranslatedText transKey="Already have account" />
        </Link>
    </div>
);

SignUpActions.propTypes = {
    registerConfirm: PropTypes.func.isRequired,
    registering: PropTypes.bool,
};
SignUpActions.defaultProps = {
    registering: false,
};

export default SignUpActions;



// WEBPACK FOOTER //
// ./src/scenes/SignUp/components/SignUpActions.js